export default __webpack_public_path__ + "static/media/3.bde1e77f.svg";